// Substitui o window.confirm nativo (feio) do Turbo por um modal shadcn-style,
// consistente com o componente `ui :dialog` da base. Registrado globalmente via
// Turbo.config.forms.confirm: TODO elemento com `data-turbo-confirm="..."`
// (links, forms, botões) passa a usar este modal automaticamente — sem tocar
// cada view.
//
// O texto do data-turbo-confirm vira a DESCRIÇÃO; o título é fixo (i18n via
// data-attrs no <html>, com fallback PT). Retorna Promise<boolean> — Turbo só
// submete se resolver true.
import { Turbo } from "@hotwired/turbo-rails"
import { activateFocusTrap, deactivateFocusTrap } from "./controllers/utils/focus_trap"
import { applyEnter, animateOut } from "./controllers/utils/motion"

// Rótulos (i18n) lidos de data-attrs no <html> quando presentes; senão PT.
function labels() {
  const ds = document.documentElement.dataset
  return {
    title:   ds.confirmTitle   || "Confirmar",
    confirm: ds.confirmConfirm || "Confirmar",
    cancel:  ds.confirmCancel  || "Cancelar"
  }
}

function buildModal(message) {
  const { title, confirm, cancel } = labels()

  const root = document.createElement("div")
  root.className = "fixed inset-0 z-50 flex items-center justify-center p-4"
  root.setAttribute("role", "dialog")
  root.setAttribute("aria-modal", "true")
  root.innerHTML = `
    <div data-backdrop class="fixed inset-0 bg-background/80 backdrop-blur-sm animate-backdrop-in"></div>
    <div data-panel class="relative z-10 w-full max-w-lg rounded-lg border bg-card p-6 shadow-xl animate-dialog-in">
      <h2 class="text-lg font-semibold mb-1">${title}</h2>
      <p class="text-sm text-muted-foreground mb-4" data-message></p>
      <div class="flex justify-end gap-2 mt-4">
        <button type="button" data-cancel
                class="inline-flex h-9 px-3 items-center rounded-md border border-input bg-background text-sm transition-colors hover:bg-accent hover:text-accent-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">
          ${cancel}
        </button>
        <button type="button" data-confirm
                class="inline-flex h-9 px-3 items-center rounded-md bg-primary text-primary-foreground hover:bg-primary/90 text-sm font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">
          ${confirm}
        </button>
      </div>
    </div>
  `
  // textContent (não innerHTML) na mensagem → evita injeção de HTML.
  root.querySelector("[data-message]").textContent = message || ""
  return root
}

function confirmWithModal(message) {
  return new Promise((resolve) => {
    const root    = buildModal(message)
    const panel   = root.querySelector("[data-panel]")
    const backdrop = root.querySelector("[data-backdrop]")
    document.body.appendChild(root)
    document.body.style.overflow = "hidden"

    applyEnter(panel, "animate-dialog-in")
    applyEnter(backdrop, "animate-backdrop-in")
    const trap = activateFocusTrap(root)
    root.querySelector("[data-confirm]").focus()

    let settled = false
    const finish = async (result) => {
      if (settled) return
      settled = true
      document.removeEventListener("keydown", onKeydown)
      await Promise.all([
        animateOut(panel, "animate-dialog-out"),
        animateOut(backdrop, "animate-backdrop-out")
      ])
      deactivateFocusTrap(trap)
      document.body.style.overflow = ""
      root.remove()
      resolve(result)
    }

    const onKeydown = (e) => {
      if (e.key === "Escape") finish(false)
      else if (e.key === "Enter") finish(true)
    }

    root.querySelector("[data-confirm]").addEventListener("click", () => finish(true))
    root.querySelector("[data-cancel]").addEventListener("click", () => finish(false))
    backdrop.addEventListener("click", () => finish(false))
    document.addEventListener("keydown", onKeydown)
  })
}

// Registra como o confirmador global do Turbo (Turbo 8).
Turbo.config.forms.confirm = confirmWithModal
